import React, { Component } from 'react';
import { LocaleContext } from '../../locale-context';
import {
    Header,
    Image,
    Button,
    Icon,
    Grid,
    Divider,
    Modal
} from 'semantic-ui-react';

const ListBlogComponent = ({ openModal, postDetails, language }) => (
    <Grid.Column onClick={openModal} className="testimonial-details">
        <div className="blog-entry">
            <div
                className="blog-entry-picture"
                style={{
                    backgroundImage: postDetails.selectedFile
                        ? `url(data:image/jpg;base64,${
                              postDetails.selectedFile
                          })`
                        : 'http://placehold.it/120x120&text=image1',
                    backgroundSize: 'cover'
                }}
            />
            <span className="blog-entry-text">{postDetails.summary}</span>
        </div>
        <div className="blog-details">
            <h3 className="heading-tertiary">{postDetails.title}</h3>
            <p className="paragraph">
                {postDetails.date} / {postDetails.author}
            </p>
            <br />
            <a onClick={openModal} href="#" className="btn-text">
                {language === 'en' ? 'Read More' : 'Citeste Mai Mult'} &rarr;
            </a>
        </div>
    </Grid.Column>
);

const ModalComponent = ({ open, closeModal, postDetails }) => (
    <Modal
        dimmer="blurring"
        style={inlineStyle.modal}
        open={open}
        onClose={closeModal}
    >
        <Modal.Header>{postDetails.title}</Modal.Header>
        <Modal.Content image>
            <Image
                wrapped
                size="medium"
                src={
                    postDetails.selectedFile
                        ? 'data:image/jpg;base64,' + postDetails.selectedFile
                        : 'http://placehold.it/120x120&text=image1'
                }
            />
            <Modal.Description>
                <Header>{postDetails.author}</Header>
                <p>{postDetails.content}</p>
            </Modal.Description>
        </Modal.Content>
    </Modal>
);

class ListBlog extends Component {
    state = {
        open: false
    };

    openModal = e => {
        e.preventDefault();

        this.setState({
            open: true
        });
    };

    closeModal = () =>
        this.setState({
            open: false
        });

    render() {
        const {
            title,
            date,
            author,
            summary,
            content,
            language,
            votes,
            blogId,
            selectedFile
        } = this.props;

        return (
            <React.Fragment>
                <ListBlogComponent
                    openModal={this.openModal}
                    postDetails={{ author, date, summary, title, selectedFile }}
                    language={language}
                />

                <ModalComponent
                    open={this.state.open}
                    closeModal={this.closeModal}
                    postDetails={{ author, content, title, selectedFile }}
                />
            </React.Fragment>
        );
    }
}

const TranslatedComponent = props => (
    <LocaleContext>
        {value => <ListBlog language={value} {...props} />}
    </LocaleContext>
);

const inlineStyle = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};

export default TranslatedComponent;



// WEBPACK FOOTER //
// ./src/components/Blog/ListBlog.js